import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseAuthDomain',
  initialState: null as null | string,
  reducers: {
    setFirebaseAuthDomain(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseAuthDomain } = slice.actions;

export default slice.reducer;
